<script setup>
import { feedbackFormValidationSchema } from '@/configs/validation';
import { routes } from '@/configs/menu';

defineProps({
  inSidebar: {
    type: Boolean,
    default: false,
  },
});

const feedbackStore = useFeedbackStore();

async function submit(values, actions) {
  try {
    await feedbackStore.sendFeedback({
      name: values.name,
      email: values.email,
      message: values.message,
    });
  } catch (error) {
    const { errors } = error;

    if (errors) {
      actions.setErrors(errors);
    } else {
      alert(error);
    }

    throw error;
  }
}

const validationSchema = feedbackFormValidationSchema();
</script>

<template>
  <div class="ctr-feedback-form" :class="{ container: !inSidebar }">
    <UiForm
      :rows-count="2"
      :validation-schema="validationSchema"
      :submit-callback="submit"
      class="ctr-feedback-form__form"
    >
      <template #row-1>
        <FormInput name="name" :label="$t('form.fields.name')" />

        <FormInput name="email" :label="$t('form.fields.email')" type="email" />
      </template>

      <template #row-2>
        <FormTextarea name="message" label="Текст комментария" />
      </template>

      <template #footer="{ isFormSubmitting, isFormSubmitted, formState }">
        <div class="ctr-feedback-form__footer">
          <FormCheckbox name="agreement" class="ctr-feedback-form__checkbox">
            {{ $t('form.fields.personalAgreement') }}
            <NuxtLink
              :to="routes.processingOfPersonalData.url"
              target="_blank"
              class="link"
            >
              {{ $t('form.fields.personalAgreementLink') }}
            </NuxtLink>
          </FormCheckbox>

          <ButtonsUnderlined
            class="ctr-feedback-form__button"
            :title="$t(`form.submit.${formState}`)"
            :disabled="isFormSubmitting"
            :type="isFormSubmitted ? 'reset' : 'submit'"
            :icon="isFormSubmitted ? 'reset' : 'link-arrow-right'"
            :active-only-icon="isFormSubmitted"
          />
        </div>
      </template>
    </UiForm>
  </div>
</template>

<style scoped lang="scss">
.ctr-feedback-form {
  &__form {
    @include media-breakpoint-up(sm) {
      padding-right: em($gap-right-safe);
    }
  }

  &__footer {
    display: flex;
    gap: em(58);
    margin-top: em(31);

    @include media-breakpoint-up(sm) {
      align-items: flex-start;
    }

    @include media-breakpoint-down(sm) {
      flex-direction: column;
      gap: em(43);
      margin-top: em(24);
    }
  }

  &__checkbox {
    flex-grow: 1;
  }

  &__button {
    width: em(401);
    flex-shrink: 0;

    @include media-breakpoint-down(sm) {
      width: 100%;
    }
  }
}
</style>
